"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const ChangePasswordMobile_1 = __importDefault(require("../forms/components/change-password-mobile/ChangePasswordMobile"));
const typography_1 = require("../../shared/typography");
const icons_1 = require("../../atoms/icons");
const styled_components_1 = __importDefault(require("styled-components"));
const BaseMobile_1 = require("./BaseMobile");
exports.default = ({ onCloseModal, onSubmit, translations, offline }) => {
    return ((0, jsx_runtime_1.jsx)(BaseMobile_1.BaseMobile, { content: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(Header, { children: [(0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(typography_1.H2, { children: translations.title }, void 0) }, void 0), (0, jsx_runtime_1.jsx)(icons_1.Icon, { shape: "rectangle", icon: ["fal", "times"], onClick: onCloseModal }, void 0)] }, void 0), (0, jsx_runtime_1.jsx)(ChangePasswordMobile_1.default, { onSubmit: onSubmit, offline: offline, translations: translations, onClose: onCloseModal }, void 0)] }, void 0) }, void 0));
};
const Header = styled_components_1.default.div `
  display: flex;
  ${({ headerInvisible }) => headerInvisible ? "visibility: hidden" : ""};
  width: 100%;
  justify-content: space-between;

  & > div:first-of-type {
    width: 90%;
    margin-left: 5%;
    display: flex;
    justify-content: center;
  }

  & > div:last-of-type {
    background-color: transparent;
  }
`;
//# sourceMappingURL=ChangePasswordMobile.js.map